module.exports = __webpack_public_path__ + "static/img/niunai.a1a0d8bd.png";